import React from 'react';
import { node } from 'prop-types';

const Person = (props) => {
  return (
    <span className="c-articlefooter__value">
      {props.FirstName} {props.LastName} {props.Title} {props.Workplace}{' '}
      {props.City}
    </span>
  );
};

export const propTypes = {
  FirstName: node,
  LastName: node,
  Title: node,
  Workplace: node,
  City: node,
};

Person.propTypes = propTypes;

export default Person;
